import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SiriusServiceModule } from '@ibtech/sirius-angular-service';
import { SiriusAppModule } from 'sirius-framework';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppInjector } from './app.injector';
import { LandingModule } from './landing/landing.module';
import { LandingLoginModule } from './login/landing-login.module';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { CommonService } from './shared/service/shared.service';
import { PopupService } from './popup/informationPopup/popup.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/modules/shared.module';
import { InnerMenuModule } from './inner-menu/inner-menu.module';
import { CookieInfoModule } from './popup/cookieinfo/cookieinfo.module';
import { AuthGuard } from './shared/auth.guard';
import { AuthService } from './shared/auth.service';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    AppComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({ cookieName: "SR-XSRF-TOKEN", headerName: "X-SR-XSRF-TOKEN" }),
    LandingModule,
    LandingLoginModule,
    InnerMenuModule,
    SiriusServiceModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    CookieInfoModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  providers: [AuthGuard, AuthService, CommonService, PopupService],
  bootstrap: [AppComponent]
})
export class AppModule extends SiriusAppModule {
  constructor(injector: Injector) {
    super(injector);
    AppInjector.setInjector(injector);
  }
}
